export default "__VITE_ASSET__BaEBihe0__"